import axios from 'axios';

export const updateUserZones = async (params) => {
  const { data } = await axios.post('/update-user-zones', params);

  return data;
};
